import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Claimants } from "../../models/claimant";
import { environment } from '../../../environments/environment.prod';

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" })
};

@Injectable({
    providedIn: "root"
})
export class ClaimantService {
    baseUrl = environment.baseUrl;

    constructor(private http: HttpClient) { }

  createClaimant(claimant: Claimants): Observable<Claimants> {
    return this.http.post<Claimants>(this.baseUrl + "Claimants", claimant, httpOptions);
    }
}

